import { find, includes, flow, isPlainObject } from 'lodash/fp'
import { addDaysToDate } from 'core/service/lib/date'
import VALUES from 'core/data-model/constants/values'

export const calculateLegalDisclaimerEndDate = (startDate) => {
  return addDaysToDate(startDate, VALUES.LEGAL_DISCLAIMER_DURATION)
}

export const isCancerRiders = flow(
  find((rider) => {
    const _cancerRiders = ['CPR', 'HIC']
    return includes(rider.code)(_cancerRiders)
  }),
  isPlainObject
)
